import CamIcon from "./images/icons/cam.svg?react";
import { useCallback } from "react";
import { useExperiment } from "@/common/hooks/useExperiment";
import { EXPERIMENT_NO_ADS } from "@/common/services/experiment/constants";
import { Button } from "@/components/buttons/Button";
import "./AdSearchLink.scss";

export const AdSearchLink = () => {
  const { isLoading, variant: noAds } = useExperiment({ key: EXPERIMENT_NO_ADS, fallback: false });

  const handleClick = useCallback(() => {
    // eslint-disable-next-line
    window.open("https://rgcams.com/landing/click/?AFNO=1-12", "_blank");
  }, []);

  if (noAds || isLoading) {
    return null;
  }

  return (
    <div className="adSearchLink" onClick={handleClick}>
      <div className="adSearchLinkIcon">
        <CamIcon />
      </div>
      <span className="adSearchLinkText">See more on RG Cams</span>
      <Button className="adSearchLinkBtn" size="xs">RG Cams</Button>
    </div>
  );
};
